// 인앱 평점 요청 — 생성 성공 직후(만족 순간)에만 띄운다.
//
// iOS 는 SKStoreReviewController, Android 는 Play In-App Review
// (@capacitor-community/in-app-review). 웹은 no-op — 웹엔 평점이 없다.
//
// OS 가 실제 표시 여부를 결정한다 (iOS 는 연 3회 상한, Android 는 Play 쿼터).
// requestReview() 호출이 항상 다이얼로그를 띄우는 게 아니므로 "떴는지" 는 알 수
// 없다. 우리 쪽 스로틀은 호출 빈도만 관리:
//   - 성공 생성 누적 2회부터 (첫 성공 직후는 아직 애착이 없다)
//   - 마지막 요청 후 60일 경과 시에만 재요청
const LAST_ASK_KEY = 'voda_review_last_ask';
const SUCCESS_COUNT_KEY = 'voda_review_gen_success';
const MIN_SUCCESSES = 2;
const ASK_COOLDOWN_MS = 60 * 24 * 60 * 60 * 1000;

import { isNativeApp } from './platform-service.js';
import { logEvent, analytics } from '../firebase.js';

function readInt(key) {
  try { return parseInt(localStorage.getItem(key) || '0', 10) || 0; } catch { return 0; }
}

export const ReviewService = {
  /**
   * 생성 성공 시마다 호출. 조건이 맞으면 OS 평점 다이얼로그를 요청한다.
   * fire-and-forget — 실패는 조용히 무시 (리뷰 요청이 UX 를 깨면 안 된다).
   */
  async onGenerationSuccess() {
    try {
      const count = readInt(SUCCESS_COUNT_KEY) + 1;
      localStorage.setItem(SUCCESS_COUNT_KEY, String(count));

      if (!isNativeApp()) return;
      if (count < MIN_SUCCESSES) return;
      const lastAsk = readInt(LAST_ASK_KEY);
      if (lastAsk && Date.now() - lastAsk < ASK_COOLDOWN_MS) return;

      localStorage.setItem(LAST_ASK_KEY, String(Date.now()));
      // 결과 이미지가 먼저 눈에 들어오도록 잠깐 뒤에 요청.
      setTimeout(async () => {
        try {
          const { InAppReview } = await import('@capacitor-community/in-app-review');
          await InAppReview.requestReview();
          logEvent(analytics, 'review_prompt_requested', { after_successes: count });
        } catch (e) {
          console.warn('review request failed:', e?.message);
        }
      }, 2500);
    } catch { /* ignore */ }
  },
};
